import { TFunction } from 'i18next';
import { Gender } from '../types/enums';

interface Option<T> {
  value: T;
  label: string;
}

export const getGenderOptions = (t: TFunction): Option<Gender>[] => [
  { value: Gender.MALE, label: t('genderOptions.male') },
  { value: Gender.FEMALE, label: t('genderOptions.female') },
  { value: Gender.OTHER, label: t('genderOptions.other') },
  { value: Gender.PREFER_NOT_TO_SAY, label: t('genderOptions.preferNotToSay') },
];

export const getMonthOptions = (t: TFunction): Option<number>[] => [
  { value: 1, label: t('months.1') },
  { value: 2, label: t('months.2') },
  { value: 3, label: t('months.3') },
  { value: 4, label: t('months.4') },
  { value: 5, label: t('months.5') },
  { value: 6, label: t('months.6') },
  { value: 7, label: t('months.7') },
  { value: 8, label: t('months.8') },
  { value: 9, label: t('months.9') },
  { value: 10, label: t('months.10') },
  { value: 11, label: t('months.11') },
  { value: 12, label: t('months.12') },
];
